import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Cache to avoid multiple API calls
let contentCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 60000; // 1 minute

export const useCMSContent = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      // Check cache
      if (contentCache && cacheTimestamp && (Date.now() - cacheTimestamp < CACHE_DURATION)) {
        setContent(contentCache);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/admin/all-content`);
        if (response.ok) {
          const data = await response.json();
          contentCache = data;
          cacheTimestamp = Date.now();
          setContent(data);
        } else {
          throw new Error('Failed to fetch content');
        }
      } catch (err) {
        setError(err.message);
        // Fallback to null - components will use their defaults
      }
      setLoading(false);
    };

    fetchContent();
  }, []);

  return { content, loading, error };
};

// Individual section hooks for components that only need specific data
export const useHeroContent = () => {
  const { content, loading } = useCMSContent();
  return { hero: content?.hero || null, loading };
};

export const useAboutContent = () => {
  const { content, loading } = useCMSContent();
  return { about: content?.about || null, loading };
};

export const useContactContent = () => {
  const { content, loading } = useCMSContent();
  return { contact: content?.contact || null, loading };
};

export const useStatsContent = () => {
  const { content, loading } = useCMSContent();
  return { stats: content?.stats || null, loading };
};

export const useFooterContent = () => {
  const { content, loading } = useCMSContent();
  return { footer: content?.footer || null, loading };
};

export const useHowItWorksContent = () => {
  const { content, loading } = useCMSContent();
  return { howItWorks: content?.how_it_works || null, loading };
};

export const useTestimonialsContent = () => {
  const { content, loading } = useCMSContent();
  return { testimonials: content?.testimonials || null, loading };
};

export const useFAQContent = () => {
  const { content, loading } = useCMSContent();
  return { faq: content?.faq || null, loading };
};

// Function to invalidate cache (call after CMS updates)
export const invalidateCMSCache = () => {
  contentCache = null;
  cacheTimestamp = null;
};
